export default __webpack_public_path__ + "static/media/wallet.fdc45a9b.png";